/**
 * Logging that is safe to leave in the codebase. RULES.MD §8: never log tokens, passwords,
 * or personal data.
 */

const isDev = import.meta.env.DEV;

/* eslint-disable no-restricted-syntax -- this module is the sanctioned console boundary */

export const logger = {
  debug(message: string, ...rest: readonly unknown[]): void {
    if (isDev) console.debug(`[debug] ${message}`, ...rest);
  },

  info(message: string, ...rest: readonly unknown[]): void {
    if (isDev) console.info(`[info] ${message}`, ...rest);
  },

  warn(message: string, ...rest: readonly unknown[]): void {
    if (isDev) console.warn(`[warn] ${message}`, ...rest);
  },

  /** Errors are reported in every environment. */
  error(message: string, ...rest: readonly unknown[]): void {
    console.error(`[error] ${message}`, ...rest);
  },
};

/* eslint-enable no-restricted-syntax */
